<div class="rate">
    <div class="rate-colored" [style.width.%]="(rate*100)/5">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star-active.svg" alt="" class="max-15">
    </div>
    <div class="rate-uncolored">
      <img src="../../../../../assets/images/star.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star.svg" alt="" class="max-15 mre-1">
      <img src="../../../../../assets/images/star.svg" alt="" class="max-15">
  </div>
